const getZendeskUrl = (lang: string, session?: string) => {
  const locale = lang === 'en' ? 'en-us' : lang;
  const tokenParam = session ? `?signin=${session}` : '';
  return `${process.env.NX_PUBLIC_API_URL ?? ''}/zendesk/${locale}${tokenParam}`;
};

export const urlPool = {
  getZendeskUrl,
};
